import { ModalProps } from "antd/lib/modal/Modal";
import { Modal, Spin } from "antd";
import React, {
    useCallback,
    useContext,
    useImperativeHandle,
    useMemo,
    useState
} from "react";
import {
    getChapter,
    getChapterProp
} from "../../../../../../service/CourseDetail/chapter";
import "../../../../../../style/public.scss";
import StuViewChaptersList from "./Components/ChaptersList";
import Style from "./index.module.scss";
import PreviewSourceModal from "../../../../../../components/PreviewSourceModal";
import { CourseContext } from "../../../../Store";
import useCurrentDate from "../../../../../../utils/useCurrentDate";
import useRequest from "../../../../../../utils/useRequest";
import { getSourceList } from "../../../../../ResourcePool/service";
import { ChapterContext } from "./store";
import useModalHandler from "../../../../../../utils/v2/useModalHandler";

interface DataModalInstance {
    setPayload: (payload: any) => void;
}
interface DataModalProps extends ModalProps {
    onOk?: () => void;
    onCancel?: () => void;
}

const DataModal = React.forwardRef<DataModalInstance, DataModalProps>(
    ({ onOk, onCancel, ...props }, ref) => {
        const [payload, setPayload] = useState({});
        useImperativeHandle(ref, () => ({
            setPayload: payload => {
                setPayload(payload);
            }
        }));
        const { course } = useContext(CourseContext);
        const { batchNo } = useCurrentDate();
        const [SourceList, { loading }] = useRequest(() =>
            getSourceList({
                batchNo,
                courseNo: course.courseNo,
                courseSeq: course.courseSeq,
                delStatus: "",
                keyword: "",
                pageNo: 1,
                pageSize: 9999
            })
        );
        const nodeParams: getChapterProp = {
            dcCoursewareSourceParam: {
                delStatus: ""
            },
            dcCourseChapterEntity: {
                batchNo,
                delStatus: "",
                courseNo: course.courseNo,
                courseSeq: course.courseSeq
            }
        };
        const [treeData, { loading: treeLoading }] = useRequest(() =>
            getChapter(nodeParams)
        );

        //预览
        const prevModal = useModalHandler(PreviewSourceModal);
        function onPrev(id: number | null) {
            if (id) {
                prevModal.setPayload(id);
                prevModal.open();
            }
        }

        const prevList = useMemo(() => {
            return SourceList?.data.filter(item => item.isPublish === 1) || [];
        }, [SourceList]);

        const onViewCourseware = useCallback(
            (id?: number) => {
                onPrev(id || prevList?.[0]?.id || null);
            },
            [prevList]
        );

        return (
            <Modal
                {...props}
                onCancel={onCancel}
                centered
                onOk={onCancel}
                maskClosable={false}
                cancelButtonProps={{ style: { display: "none" } }}
                okButtonProps={{ style: { display: "none" } }}
                title="学生视角查看">
                <Spin spinning={loading || treeLoading}>
                    <div className={Style.root}>
                        <ChapterContext.Provider
                            value={{
                                onViewCourseware
                            }}>
                            <StuViewChaptersList data={treeData || []} />
                            {prevModal.render(
                                <PreviewSourceModal
                                    type="student"
                                    data={prevList || []}
                                />
                            )}
                        </ChapterContext.Provider>
                    </div>
                </Spin>
            </Modal>
        );
    }
);

export default DataModal;
